import { Component, OnInit } from '@angular/core';
import { Pol } from './pol';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-pol-modal-update',
  templateUrl: './pol-modal-update.component.html'
})
export class PolModalUpdateComponent extends BaseModalUpdateComponent<Pol> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Pol>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);    
  }

  ngOnInit() {
  }

}
